import request from 'network/request';

export function getSearchHotWord() {
  return request({
    url: '/goods/home/extend/search/popular',
    method: 'get'
  });
}
